const bullets = new Swiper("#bullets", {
	loop: true,
	speed: 2000,
	effect: 'fade',
	autoplay: {
		delay: 4000,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev"
	},
	pagination: {
		el: ".swiper-pagination",
		type: "bullets",
		clickable: "clickable"
	}
});
